module.exports = __webpack_public_path__ + "media/images/home-3c97a7faa9cb6a8cb5e89ce267730c65.png";